import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import {
  AdvancedCardSearch,
  FullProps,
} from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';

export const BaseballCardSearch = (props: Omit<FullProps, 'sport'>) => (
  <AdvancedCardSearch sport={Sport.BASEBALL} {...props} />
);
